import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=7dcc6878&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=7dcc6878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc6878",
  null
  
)

export default component.exports